function initialiseReviewCarousel() {
  jQuery(function ($) {
    let carousel = new Swiper(
      '.curated-reviews__carousel.swiper:not(.swiper-initialized)',
      {
        spaceBetween: 8,
        slidesPerView: 'auto',
        allowTouchMove: true,
        scrollbar: {
          el: '.curated-reviews__carousel-scrollbar',
          draggable: true,
          dragSize: 103,
        },
        breakpoints: {
          1024: {
            spaceBetween: 24,
          },
        },
      },
    );
  });
}

window.addEventListener('DOMContentLoaded', function () {
  initialiseReviewCarousel();
});
